import React from 'react';
import { Link } from "react-router-dom";
import { Load, DeleteItem, Confirm } from './partials/PopUps.js';
import AddProductModal from './Productos/AddProductModal.js';
import EditProductModal from './Productos/EditProductModal.js';
import { toast } from 'react-toastify';
const ItemsProduct = (props) => {
	const { producto, openmodal, removeItem, isSelect, moveTrash, sesion } = props;
	return (
		<tr key={producto.id}>
			<td><input type="checkbox" checked={producto.select} onChange={isSelect} name="productoID" value={producto.id}/></td>
			<td className="codigo">{producto.codigo}</td>
			<td className="producto text-left">{producto.nombre}</td>
			<td className="precio">{window.$fmoney(producto.precio,2)}</td>
			<td className="existencia">{producto.stock}</td>
			<td className="operaciones">
				<span className="icon-pencil" title="Editar" onClick={()=>openmodal(producto.id)}></span>
				{ ( sesion.rol === 1 && producto.status === true ) ? <span className="icon-trash" title="Mover a papelera" onClick={()=>moveTrash(producto.id)}></span> : ''}
				{ ( sesion.rol === 1 && producto.status === false ) ? <span className="restaurar" title="Restaurar" onClick={()=>moveTrash(producto.id)}>&#x267a;</span> : ''}
				{ ( sesion.rol === 1 && producto.status === false ) ? <span className="icon-close" title="Eliminar" onClick={()=>removeItem(producto.id)}></span> : '' } 
			</td>
		</tr>
	)
}

class Productos extends React.Component{
	constructor(props){
		super(props);
		this.state = { 
			openModal : false,
			modalNew : false,
			display : {
				delete : false,
				load : true,
				confirm : false,
				success : false,
				new : false,
			},
			productos : [],
			sucursales : [],
			productosDefault : [],
			producto : {},
			search : '',
			action : '',
			message : '',
			defaultProduct : {},
			publish : true,
			trash : false,
			ModalView : false,
			objProductNew: {
				stock : 0,
				stockinv : 0,
				codigo : '',
				nombre :'',
				precio : '',
				descripcion : '',
				sucursales : [],
				proveedor : {}
			},
			filtroProveedor : '',
			// Modal
			showModal :false,
			titleModal : '',
			mensajeModal : '',
			errorcodigo : true,
		};
		this.sesion = JSON.parse( localStorage.getItem('sesion'));
	}
	componentDidMount(){
		this.mounted = true;
		if( this.mounted === true ){
			fetch(window.$api+'/productos')
			.then(res=>res.json())
			.then(res=>{
				const productos = res.productos;
				const sucursales = res.sucursales;
				const productosDefault = JSON.parse( JSON.stringify( res.productos ) );
				const display = { load : ! this.state.display.load };
				this.setState({productos,productosDefault,sucursales, display });
			});
			let self = this;
			let scannedBarcode="";
			document.onkeydown = e => {
				if (e.key !== "Enter" ) {
					scannedBarcode += e.key;
				}
				if (e.key === "Enter" ) {
					scannedBarcode = scannedBarcode.replace("'","-");
					scannedBarcode = scannedBarcode.trim();
					self.searchWithProducts(scannedBarcode);
					scannedBarcode = '';
				}
			};
		}
	}
	componentWillUnmount() {
		this.mounted = false;
		this.setState = () => false;
		window.onkeydown = null;
	}
	resta = (operacion, id) => {
		// Obtenemos el producto que estamos capturando
		let producto = JSON.parse( JSON.stringify( this.state.producto ) );
		let exist1 = 0, exist2 = 0, stock = 0;
		producto.sucursales.map((sucursal,index)=>{
			if( sucursal.existencia2 > 0 ){
				if( parseInt(sucursal.id) === parseInt(id) ){
					// encontramos la sucursal y verificamos si el valor a asignar no excede al stock
					if( operacion === '+' ){
						if( sucursal.existencia2 <= producto.stock){
							sucursal.existencia = Number(sucursal.existencia) + Number(sucursal.existencia2);
							producto.stock = Number(producto.stock) - Number(sucursal.existencia2);
							sucursal.existencia2 = 0;
						}else{
							toast.warning('No puedes asignar una cantidad mayor a la que tienes en stock');
						}
					}
					// Al igual que el bloque anterior, aquí con la diferencia de que verificamos 
					// si la existencia que queremos restar no excede a la actual
					if( operacion === '-' ){
						exist1 = parseInt(sucursal.existencia);
						exist2 = parseInt(sucursal.existencia2);
						stock = parseInt(producto.stock);
						if( exist2 <= exist1 ){
							sucursal.existencia = exist1 - exist2;
							producto.stock = stock + exist2;
							sucursal.existencia2 = 0;
						}else{
							toast.warning('No puedes devolver una cantidad mayor a la que tienes en sucursal');
						}
					}
				}
			}
			return sucursal;
		});
		this.setState({producto});
	}
	restaNew = (operacion, id) => {
		id = parseInt(id);
		// Obtenemos el producto que estamos capturando
		let objProductNew = JSON.parse( JSON.stringify( this.state.objProductNew ) );
		objProductNew.sucursales.map((sucursal,index)=>{
			
			if( sucursal.existencia2 > 0 ){
				// encontramos la sucursal y verificamos si el valor a asignar no excede al stock
				if( operacion === '+' ){
					if( parseInt(sucursal.id) === id
					&& sucursal.existencia2 <= objProductNew.stock){
						sucursal.existencia = Number(sucursal.existencia) + Number(sucursal.existencia2);
						objProductNew.stock = Number(objProductNew.stock) - Number(sucursal.existencia2);
						sucursal.existencia2 = 0;
					}
				}
				// Al igual que el bloque anterior, aquí con la diferencia de que verificamos 
				// si la existencia que queremos restar no excede a la actual
				if( operacion === '-' ){
					if(
						parseInt(sucursal.id) === id
						&& sucursal.existencia2 <= sucursal.existencia ){
						sucursal.existencia = Number(sucursal.existencia) - Number(sucursal.existencia2);
						objProductNew.stock = Number(objProductNew.stock) + Number(sucursal.existencia2);
						sucursal.existencia2 = 0;
					}else{
						toast.warning('No puedes devolver una cantidad mayor al stock, de la que tienes en existencia...');
					}
				}
			}
			return sucursal;
		});
		this.setState({objProductNew});
	}
	inputHandler = (e, sid = null) => {
		let input = e.target;
		let producto = {...this.state.producto};
		let sucursales = producto.sucursales;
		if( sid > 0 ){
			sucursales = sucursales.map((e)=>{
				if( parseInt(e.id) === parseInt(sid) ){
					e.existencia2 = Number(input.value);
				}
				return e;
			});
		}else{
			producto[input.name] = input.value;
		}
		producto.sucursales = sucursales;
		this.setState({producto});
	} 
	inputHandlerNew = (e, sid = null) => {
		let input = e.target;
		let producto = JSON.parse(JSON.stringify( this.state.objProductNew ));
		this.setState(state=>{
			if( sid > 0 ){
				producto.sucursales.map((e)=>{
					if( e.id === sid ){
							e.existencia2 = Number(input.value);
					}
					return e;
				});
			}else{
				producto[input.name] = input.value;
			}
			return {
				objProductNew : JSON.parse(JSON.stringify(producto))
			}
		});
	}
	searchWithProducts = codigo =>{
		let productos = this.state.productosDefault.filter(p=>p.codigo===codigo);
		this.setState({productos});
	}
	removeAccents = (str) => {
		return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	} 
	searchHandler = (e) =>{
		let search = e.target.value;
		search = search.replace("'","-");
		let productos = this.state.productosDefault.filter(prod=>{
				const codigo = prod.codigo.toUpperCase();
				let itemData = prod.nombre.toUpperCase();
				let textData = search.toUpperCase();
				
				if( codigo.search(textData) > -1 ){
					return prod;
				}
				itemData = this.removeAccents(itemData);
				textData = this.removeAccents(textData);
				
				if(itemData.search(textData) > -1){
					return prod;
				}
				return false;
		});
		this.setState({search,productos});
	}
	updateProducts = () => {
		const productos = this.state.productosDefault;
		this.setState({productos});
	}
	moveTrash = (id) => {
		let productos = JSON.parse( JSON.stringify( this.state.productosDefault ) );
		let producto = productos.find(e=>e.id===id);
		producto.status = !producto.status;
		let body = {
			session : this.sesion,
			content : producto
		}
		let config = {
			method : 'PUT', 
			body : JSON.stringify( body ),
			headers : { 'Content-Type': 'application/json' },
		};
		this.setState({display :{ load: !this.state.display.load } });
		fetch(window.$api+'/productos/'+id,config)
		.then(res=>res.json())
		.then(producto=>{
			let nombre, status;
			productos = productos.map(e=>{
					if(e.id === producto.id ){
						nombre = producto.nombre;
						status = producto.status;
						return producto;
					}else{
						return e;
					}
			});
			const productosDefault = JSON.parse( JSON.stringify( productos ) );
			if( status === true ){
				toast.success('El producto: '+nombre+' se ha movido a publicado');
			}else{
				toast.success('El producto: '+nombre+' se ha movido a la papelera');
			}
			const display = { 
				success : !this.state.display.success,
				display: !this.state.display.load
			}
			
			const action = "success";
			this.setState({display, productosDefault, productos, action});
		});
	}
	isSelect = (e) => {
		let value = e.target.value;
		let productos = JSON.parse( JSON.stringify( this.state.productos ) );
		if( value === 'all'){
			const valor = e.target.checked;
			productos.map(e=>{
				if( valor === true ){
					e.select = true;
				}else{
					e.select = false;
				}
				return e;
			});
		}else{
			value = Number(value);
			productos.map(e=>{
				if( e.id === value ){
						e.select = !e.select;
					return e;
				}else{
					return e;
				}
			});
		}
		this.setState({productos});
	}
	discardChange = () => {
		this.setState(state=>{
			return{
				producto : state.defaultProduct,
				openModal : !state.openModal,
				display : { confirm : !state.display.confirm }
			}
		});
	}
	closeModalUniversal = ()=>{
		const showModal = !this.state.showModal;
		const titleModal = '';
		const mensajeModal = '';
		this.setState({showModal,titleModal,mensajeModal});
	}
	closeModal = () => {
		if( this.state.producto.id ){
			const display = { confirm : !this.state.display.confirm };
			this.setState({display})
		}else{
			this.setState(state=>({
				openModal : !state.openModal
			}));
		}
	}
	// save product
	addProduct = (e) => {
		e.preventDefault();
		
		let _product = JSON.parse(JSON.stringify(this.state.objProductNew));
		if( _product.codigo !== '' && _product.nombre !== '' && _product.precio !== '' ){
			const display = { load : !this.state.display.load }
			this.setState({display});
			let config = {
				method : 'POST',
				body : JSON.stringify( _product ),
				headers : { 'Content-Type': 'application/json' }
			};
			fetch(window.$api+'/productos',config)
			.then(res=>res.json()).then(
				producto=>{
					toast.success('Registro realizado con éxito...');
					const objProductNew = {
							codigo : '',
							nombre :'',
							precio : '',
							stock : 0,
							stockinv : 0,
							descripcion : '',
							sucursales : [],
							proveedor : {}
					}
					const display = { load : !this.state.display.load }
					const modalNew = !this.state.modalNew;
					let productos = JSON.parse( JSON.stringify( this.state.productos ) );
					productos.unshift(producto);
					const productosDefault = JSON.parse( JSON.stringify( productos ) );
					this.setState({productos,modalNew,objProductNew, productosDefault,display});
				},
				error=>{
					const display = { load : !this.state.display.load, success : !this.state.display.success }
					const action = 'error';
					const message = "Intente nuevamente o mas tarde";
					this.setState({display,action, message});
				}
			);
		}else{
			toast.warning("Datos incompletos");
		}
	}
	onNewProduct = () => {
		const objProductNew = { 
			codigo : '',
			nombre :'',
			precio : '',
			stock : 0,
			stockinv : 0,
			descripcion : '',
			sucursales : this.state.sucursales
		}
		const modalNew = !this.state.modalNew;
		this.setState({objProductNew, modalNew});
	}
	closeModalNew = () => {
		this.setState({modalNew : !this.state.modalNew});
	}
	showPublishTrash = () => {
		const trash = this.state.publish;
		const publish = this.state.trash;
		let productosDefault = JSON.parse( JSON.stringify( this.state.productosDefault ));
		let productos = [];
		if( trash === true ){
			productosDefault.forEach(e=>{
				
				if( e.status===false ){
					productos.push(e);
				}
			});
		}
		if( publish === true ){
			productosDefault.forEach(e=>{
				if( e.status=== true ){
					productos.push(e);
				}
			});
		}
		this.setState({trash,publish,productos});
		
	}
	setEstatus = () => {
		const filtrados = this.state.productos.filter(producto=>producto.select===true);
		let action = 'moveTrashProducts';
		if( this.state.estatusProducts === "2" ){
			action = 'deleteProducts';	
		}
		let updateEstatus = 'restaurar';
		if( this.state.publish === true){
			updateEstatus = 'papelera';
		}
		if( typeof filtrados.length && filtrados.length > 0 ){
			const display = { load : !this.state.display.load }
			this.setState({display});
			fetch(window.$api+'/'+action,{
				method : 'POST',
				body : JSON.stringify( { productos : filtrados, accion : updateEstatus }),
				headers : {'Content-Type': 'application/json'}
			})
			.then(res=>res.json()).then(
				response=>{
				
					let productosDefault = JSON.parse( JSON.stringify( this.state.productosDefault ) );
					for( let x = 0; x < response.length; x++){
						for( let y = 0; y < productosDefault.length; y++){
							if( productosDefault[y].id === response[x].id ){
								productosDefault[y].status = response[x].status;
							}
						}
					}
					let productos=[];
					if( this.state.publish === true){
						productos = productosDefault.filter(e=>e.status===true);
					}else{
						productos = productosDefault.filter(e=>e.status===false);
					}
					const display = { load : !this.state.display.load };
					this.setState({productos, productosDefault,display});
				},
				error=>{
					const display = { load : !this.state.display.load, success : !this.state.display.success }
					const action = 'error';
					const message = "Intente nuevamente o mas tarde";
					this.setState({display,action, message});
				}
			);
		}else{
			const showModal = !this.state.showModal;
			const titleModal = '¡Aviso!';
			const mensajeModal = 'Selecciona primero tus elementos';
			this.setState({showModal,titleModal,mensajeModal});
		}
	}
	switchEstatus = (e) => {
		const estatusProducts = e.target.value;
		this.setState({estatusProducts});
	}
	switchProveedor = (e) => {
		let elProveedor = e.target.value;
		const filtroProveedor = e.target.value;
		if( elProveedor === 'all' ){
			const productos = JSON.parse( JSON.stringify( this.state.productosDefault ) );
			this.setState({productos});
		}else{
			let productos = this.state.productosDefault.filter(e=>e.proveedor.nombre === elProveedor);
			productos = JSON.parse( JSON.stringify( productos ) );
			this.setState({productos,filtroProveedor});
		}
	}
	clearFilter = () => {
		const filtroProveedor = "all";
		let productos = JSON.parse( JSON.stringify( this.state.productosDefault ) );
		this.setState({productos,filtroProveedor});
	}
	modalView = (id) =>{
		const ModalView = ! this.state.ModalVieidw;
		const objProductNew = this.state.productos.find(e=>e.id===id);
		this.setState({ModalView, objProductNew});
	}
	closeModalView = () => {
		const ModalView = ! this.state.ModalView;
		const objProductNew = {
			nombre :'',
			precio : '',
			descripcion : '',
			sucursales : [],
			proveedor : {}
		};
		this.setState({ModalView, objProductNew});
	}
	windowCloseUpdate = (_action) => {
		let display = {};
		switch(_action){
			case 'delete':
				display = { success : !this.state.display.success }
				this.setState({display});
			break;
			case 'error' :
				display = { success : !this.state.display.success }
				this.setState({display});
			break;
			default:
				const defaultProduct = {};
				const objProductNew = {}
				const producto={};
				display = { success : !this.state.display.success }
				this.setState({producto,defaultProduct,objProductNew,display});
		}
		
	}
	closeModalDelete = () => {
		this.setState(state=>{
			const display = { delete : !state.display.delete}
			return{
				display,
				nombre:'',
				producto_id :''
			}
		});
	}
	deleteItem = ()=>{
		const productos = this.state.productosDefault.filter(item=>item.id !== this.state.producto.id);
		const productosDefault = JSON.parse( JSON.stringify( productos ) );
		
		let config = {
			method : 'DELETE'
		};
		
		this.setState({ display : { load : !this.state.display.load } });
		fetch(window.$api+'/productos/'+this.state.producto.id, config)
		.then(res=>res.json()).then(response=>{
			this.setState(state=>{
				const display = { success : !state.display.success };
				return{
					productos,
					productosDefault,
					display
				}
			});
		});
	}
	removeItem=(id, action)=>{
		const producto = this.state.productos.find(item=>item.id===id);
		this.setState(state=>{
			const display = { delete : !state.display.delete}
			return{
				display,
				producto : JSON.parse(JSON.stringify(producto))
			}
		});
	}
	openEditModal = (id) => {
		let producto = JSON.parse( JSON.stringify( this.state.productos.find(e=>e.id===id) ));
		let sucursales = JSON.parse( JSON.stringify(this.state.sucursales) );
		sucursales.forEach((s,i)=>{
			if( producto.sucursales[i] === undefined ){
				producto.sucursales.push(s);
			}
		})
		this.setState((state, props)=>{
			return{
				producto : JSON.parse( JSON.stringify(producto) ),
				defaultProduct : JSON.parse( JSON.stringify(producto) ),
				openModal : !state.openModal
			}
		});
	}
	adminStock= (operacion) => {
		const nuevo = this.state.producto.stockinv;
		let producto = this.state.producto;
		let result = 0;
		if( operacion === '+' ){
			result = Number(nuevo) + Number(producto.stock);
		}else{
			result = Number(producto.stock) - Number(nuevo);
		}
		if( result >=  0){
			producto.stock = result;
			producto.stockinv = 0;
			this.setState({producto});
		}
	}
	adminNewStock= (operacion) => {
		let objProductNew = JSON.parse( JSON.stringify( this.state.objProductNew ) );
		let result = 0;
		if( operacion === '+' ){
			result = Number(objProductNew.stockinv) + Number(objProductNew.stock);
		}else{
			result = Number(objProductNew.stock) - Number(objProductNew.stockinv);
		}
		if( result >=  0){
			objProductNew.stock = result;
			objProductNew.stockinv = 0;
			this.setState({objProductNew});
		}
	}
	// valida si existe otro producto con el código capturado después de salir del campo
	blurCodigo = (e) =>{
		let productos = this.state.productosDefault.filter(producto=>producto.id!==this.state.producto.id);
		const codigo = this.state.producto.codigo;
		const producto = productos.find(e=>e.codigo===codigo);
		const errorcodigo = ( producto === undefined ? true : false );
		this.setState({errorcodigo});
	}
	blurCodigoNew = (e) => {
		const codigo = e.target.value;
		const producto = this.state.productos.find(e=>e.codigo===codigo);
		const errorcodigo = ( producto === undefined ? true : false );
		this.setState({errorcodigo});
	}
	// update
	mySubmitHandler = (e) => {
		e.preventDefault();
		let body = {
			session : this.sesion,
			content : this.state.producto
		}
		let config = {
			method : 'PUT',
			body : JSON.stringify(body),
			headers : {'Content-Type': 'application/json'}
		};
		if( this.state.producto.codigo !== '' && this.state.producto.nombre !== '' && this.state.producto.precio !== '' ){
			this.setState({display :{ load: !this.state.display.load } });
			fetch(window.$api+'/productos/'+this.state.producto.id,config)
			.then(res=>res.json())
			.then(producto=>{
				toast.success('Producto: '+producto.nombre+' Actualizado...');
				let pDefault = JSON.parse( JSON.stringify( this.state.productosDefault ) );
				const productos = this.state.productos.map(e=>{
					if(e.id === producto.id){
						return producto;
					}else{
						return e;
					}
				});
				const productosDefault = pDefault.map(e=>{
					if(e.id === producto.id){
						return producto;
					}else{
						return e;
					}
				});
				const display = { 
					success : !this.state.display.success,
					display: !this.state.display.load
				}
				const openModal = !this.state.openModal;
				const action = "success";
				producto={};
				this.setState({productos,display,openModal,action, producto, productosDefault});
			});
		}else{
			toast.warning("Datos incompletos");
		}
	}
	actived = (arg) => {
		return this.props.match.path === arg ? 'actived' : '';
	}
	render(){
		let list = [];
		let countPublish = 0;
		let countTrash = 0;
		
		if( this.state.productos.length > 0 ){
			this.state.productos.forEach((producto, index)=>{
				if( producto.status === this.state.publish ){
					list.push(
						<ItemsProduct 
							key={producto.id}
							producto={producto}
							number_format={this.number_format}
							openmodal={this.openEditModal}
							removeItem={this.removeItem}
							isSelect={this.isSelect}
							moveTrash={this.moveTrash}
							modalView={this.modalView}
							sesion={this.sesion}
						/>
					);
				}
			});
			this.state.productosDefault.forEach((producto)=>{
				if( producto.status === true ){
					countPublish ++;
				}else{
					countTrash ++;
				}
			});
		}
		let html;
		if(this.mounted === true ){
		html = (
			
			<div className="wrap-module">
				<div>
					<div className="xs-12 sm-6 md-6 lg-6 menuProductos">
						<Link to="/productos" className={this.actived('/productos')}>Productos</Link>
					</div>
					<div className="xs-12 sm-6 md-6 lg-6 text-right">
						<span 
							className={this.state.publish ? 'ptrash bold' : 'ptrash' }
							onClick={this.showPublishTrash}
						>	
							Publicado ({countPublish})
						</span> / 
						<span className={this.state.trash ? 'ptrash bold' : 'ptrash' }
							onClick={this.showPublishTrash}
						>Papelera({countTrash})</span>
					</div>
				</div>
				<div className="wrap-content">
					<div className="xs-12 sm-4 md-4 lg-4">
						<div className="content-search">
							<input type="text" placeholder="Buscar…" onChange={this.searchHandler} value={this.state.search}/>
							<div className="">
								<span className="icon-lupa"></span>
							</div>
						</div>
					</div>
					<div className="xs-12 sm-4 md-4 lg-4">
						<select 
							name="acciones" 
							onChange={this.switchEstatus}
							value={this.state.estatusProducts} 
							style={{padding: '8px 10px'}}
						>
							<option value="">Acciones en lote</option>
							{this.state.publish && <option value="1">Enviar a papelera</option>}
							{this.state.trash && <option value="1">Restaurar</option>}
							<option value="2">Eliminar seleccionados</option>
						</select>
						<div className="btn-medium btn-green margin-20" onClick={this.setEstatus}>Aplicar</div>
					</div>
					<div className="xs-12 sm-5 md-4 lg-4 text-right">
						{ this.sesion.rol === 3 && <div className='btn-medium btn-green' onClick={this.onNewProduct}>Agregar producto</div> }
						{  this.sesion.rol === 1 ? 
								<div>
								<div className='btn-medium btn-green' onClick={this.onNewProduct}>Agregar producto</div>
								<Link to="/descuentos" className="btn-medium btn-green">Descuentos</Link></div>
							: ''
						}
					</div> 
					<div className="xs-12 sm-12 md-12 lg-12 text-left">
						<strong style={{"color":"#E05F9D", "cursor" : "pointer"}} onClick={this.updateProducts}>Ver todos los productos</strong>
					</div>
					<div className="xs-12 sm-12 md-12 lg-12">
						<table>
							<thead>
								<tr key={1}>
									<th className="th"><input type="checkbox" value="all" onChange={this.isSelect}/></th>
									<th className="th">Código</th><th className="th">Articulo</th>
									<th className="th">Precio</th><th className="th">Existencia</th>
									<th className="th">Acción</th>
								</tr>
							</thead>
							<tbody>{this.state.productos.length > 0 ? list : ''}</tbody>
						</table>
					</div>
					</div>
					
					<Confirm display={this.state.display.confirm} discard={this.discardChange} onSubmit={this.mySubmitHandler}/>
					<DeleteItem 
						display={this.state.display.delete} 
						name={this.state.nombre} 
						closeModalDelete={this.closeModalDelete}
						deleteItem={this.deleteItem}
					/>
				{
					this.state.modalNew && 
					<AddProductModal
						visible={this.state.modalNew}
						addProduct={this.addProduct}
						blurCodigo={this.blurCodigoNew}
						closeModalNew={this.closeModalNew}
						producto={this.state.objProductNew}
						handler={this.inputHandlerNew}
						errorcodigo={this.state.errorcodigo}
						resta={this.restaNew}
						adminStock={this.adminNewStock}
					/>
				}

				{
					this.state.openModal && 
					<EditProductModal
						visible={this.state.openModal}
						submit={this.mySubmitHandler}
						close={this.closeModal}
						producto={this.state.producto}
						handler={this.inputHandler}
						sucursales={this.state.sucursales}
						sesion={this.sesion}
						resta={this.resta}
						blurCodigo={this.blurCodigo}
						errorcodigo={this.state.errorcodigo}
						adminStock={this.adminStock}
					/>
				}
			</div> 
		);
		}else{
			html = <Load display={this.state.display.load}/>;
		}
		return html;
	}
}
export default Productos;

				// if( codigo.indexOf(textData) > -1 ){
				// 	return prod;
				// }
				// if(itemData.indexOf(textData) > -1){
				// 	return prod;
				// 	// itemData.indexOf( (textData.toUpperCase()) ) > -1;
				// }